import { useParams } from "react-router-dom";
//import locales
import { useTranslation } from "react-i18next";
import "../i18n";

export default function NotFound() {

    //get locale
    const { locale } = useParams();
    const { t } = useTranslation();

    return (
        <>
            <div className='container mx-auto mt-12'>
                <div className='grid grid-cols-12 gap-5'>
                    <div className='col-span-12'>
                        404 not found
                    </div>
                </div>
            </div>
        </>
    );
}